import React, { useState } from 'react';
import { StatementCard, StatementData } from './StatementCard';
import { ScoreDistributionModal } from '../ScoreDistributionModal';

interface StatementCardWithModalProps {
    statement: StatementData;
    isAdmin?: boolean;
    theme?: 'dark' | 'light';
}

export const StatementCardWithModal: React.FunctionComponent<StatementCardWithModalProps> = ({
    statement,
    isAdmin = false,
    theme = 'light'
}) => {
    const [scoreDistributionModal, setScoreDistributionModal] = useState<{
        visible: boolean;
        statement?: StatementData;
    }>({ visible: false });

    const handleResponseCountClick = (clickedStatement: StatementData) => {
        setScoreDistributionModal({
            visible: true,
            statement: clickedStatement
        });
    };

    return (
        <>
            <StatementCard
                statement={statement}
                isAdmin={isAdmin}
                onResponseCountClick={handleResponseCountClick}
                theme={theme}
            />

            {scoreDistributionModal.statement && (
                <ScoreDistributionModal
                    visible={scoreDistributionModal.visible}
                    onClose={() => setScoreDistributionModal({ visible: false })}
                    statementText={scoreDistributionModal.statement.text}
                    responseCount={scoreDistributionModal.statement.responseCount}
                    scoreDistribution={scoreDistributionModal.statement.scoreDistribution}
                    questionType={
                        scoreDistributionModal.statement.questionTypeId === 1 ? 'likert7' :
                        scoreDistributionModal.statement.questionTypeId === 9 ? 'likert7_with_na' :
                        scoreDistributionModal.statement.questionTypeId === 7 ? 'nps' :
                        'other'
                    }
                    theme={theme}
                />
            )}
        </>
    );
};
